import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { PropType } from "vue";
import { storeToRefs } from "pinia";
import { zonedTimeToUtc } from "date-fns-tz";

import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimezoneSpan',
  props: {
  locale: {
    type: String,
    required: true,
  },
  dateStyle: {
    type: String as PropType<"full" | "long" | "medium" | "short">,
    required: false,
    default: "short",
  },
  timeStyle: {
    type: String as PropType<"full" | "long" | "medium" | "short">,
    required: false,
    default: "long",
  },
  date: {
    type: String,
    required: false,
  },
  showTime: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  setup(__props) {

const { timezone, short_timezone } = storeToRefs(useUserStore());



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showTime)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.date ? _unref(zonedTimeToUtc)(__props.date, _unref(timezone)).toLocaleString("en-GB", { weekday: "long", year: "numeric", month: "long", day: "numeric" }) : "") + " " + _toDisplayString(_unref(short_timezone)), 1))
      : _createCommentVNode("", true),
    (!__props.showTime)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.date ? _unref(zonedTimeToUtc)(__props.date, _unref(timezone)).toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "numeric" }) : ""), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})